import { combineReducers } from "redux";
import wallet_history from "../features/admin/wallet/wallet_history/Slice";
import intrest_history from "../features/admin/wallet/intrest_history/Slice";
import commission_history from "../features/admin/wallet/commission_history/Slice";
import about_me from "../features/admin/wallet/about_me/Slice";

const Wallet = combineReducers({
  wallet_history: wallet_history,
  intrest_history: intrest_history,
  commission_history: commission_history,
  about_me: about_me,
});

export default Wallet;
